var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v("Product Price (" + _vm._s(_vm.company) + ")"),
        ]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "form-wrapper",
          { staticClass: "form-wrapper", attrs: { validator: _vm.$v.form } },
          [
            _c(
              "form-group",
              { attrs: { name: "currency", label: "Currency" } },
              [
                _c("md-input", {
                  attrs: { type: "hidden" },
                  model: {
                    value: _vm.form.currency,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "currency", $$v)
                    },
                    expression: "form.currency",
                  },
                }),
                _c("vue-select", {
                  attrs: {
                    "data-testid": "form-currency",
                    options: _vm.currencyOptions,
                    clearable: false,
                  },
                  model: {
                    value: _vm.form.currency,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "currency", $$v)
                    },
                    expression: "form.currency",
                  },
                }),
              ],
              1
            ),
            _c(
              "form-group",
              {
                staticClass: "custom-textarea",
                attrs: { name: "amount", label: "Amount" },
              },
              [
                _c("md-input", {
                  model: {
                    value: _vm.form.amount,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "amount", $$v)
                    },
                    expression: "form.amount",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-primary",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.update($event)
              },
            },
          },
          [_vm._v("\n            Update\n        ")]
        ),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("\n            Cancel\n        ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }